import React, { useState } from 'react';
import { Loader2Icon } from 'lucide-react';
import { useTranslation } from '../../i18n/LanguageContext';

const DeleteModal = ({ isOpen, onClose, onDelete, title, message }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    if (!isOpen) return null;

    const handleDelete = async () => {
        setIsLoading(true);
        try {
            await onDelete();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-[#D6D6D6B2] bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50" onClick={onClose}>
            <div className="bg-white flex flex-col justify-center items-center rounded-lg pr-4 pl-4 pt-10 pb-10 w-full max-w-md text-center" onClick={e => e.stopPropagation()}>
                <div className="mb-4">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 21C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99933 19.5493 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z" fill="#FF4444"/>
                    </svg>
                </div>
                <h2 className="text-2xl font-bold mb-4">{title || t('deleteModal.defaultTitle')}</h2>
                {/* `break-words` lets long filenames (no spaces, no hyphens —
                    e.g. 20251216_Initial_Workpackages_Roadmap_DocAI.pdf) wrap
                    inside the modal instead of overflowing past its right
                    edge. The width follows the modal (max-w-md) with a small
                    horizontal padding so the message stays inside the card. */}
                <div className="mb-6 text-custom-gray w-full max-w-full px-4 break-words [overflow-wrap:anywhere]">
                    {message || t('deleteModal.defaultMessage')}
                </div>
                <div className="flex justify-end space-x-4 text-black">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className={`flex items-center gap-2 px-4 py-2 bg-custom-gray_white text-custom-gray rounded transition duration-200 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                        <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.9 19L5.5 17.6L11.1 12L5.5 6.4L6.9 5L12.5 10.6L18.1 5L19.5 6.4L13.9 12L19.5 17.6L18.1 19L12.5 13.4L6.9 19Z" fill="#5F6368" />
                        </svg>
                        {t('deleteModal.cancelButton')}
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={isLoading}
                        className={`flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded transition duration-200 hover:bg-red-600 min-w-[150px] justify-center ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                        {isLoading ? (
                            <>
                                <Loader2Icon className="w-5 h-5 animate-spin" />
                                <span>{t('deleteModal.deleting')}</span>
                            </>
                        ) : (
                            <>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 21C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99933 19.5493 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z" fill="white"/>
                                </svg>
                                <span>{t('deleteModal.deleteButton')}</span>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
